import { Injectable } from '@angular/core';
import { Configuration } from '../../../app.config';
import { IntegrationPayload } from '../Models/IntegrationPayload';
import { HttpClient } from '@angular/common/http';
import { integrationProfile } from '../Models/integrationProfile';

@Injectable()
export class IntegrationService {
  config : Configuration = new Configuration();
  payload : IntegrationPayload;
  integrationProfile: integrationProfile;
  apiEndpoint : string = this.config.PhenomURL + 'api/Screening';
  ApplicantId$ : string;
  constructor(private http : HttpClient) { }

  fetchPayload(applicantId : string) {
    return this.http.get<IntegrationPayload>(this.apiEndpoint + `/${applicantId}`)
  }

  fetchintegrationProfile(profileId:string)
  {
    return this.http.get<integrationProfile>(this.config.APIBaseUrl + `api/Screening/integration/${profileId}`)
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/services/integration.service.ts